import gql from "graphql-tag";

export const POST_TO_SNS = gql`
  mutation postToSns {
    postToSns
  }
`;